<template>
    <div class="box">
        <no-data v-if="tableData.length == 0"></no-data>
        <div class="content-container" v-else>
            <div class="left-content-box" v-infinite-scroll="load">
                <div v-for="(item, index) in tableData" class="left-item"
                    :class="{ 'active-item': item.id == currentId }" @click="showCourse(item)" :key="index">
                    <el-tooltip placement="top-start" :disabled="item.taskName>18?false:true" :content="item.taskName" effect="dark">
                        <p class="task-name overflow">{{ item.taskName }}</p>
                    </el-tooltip>
                    <div class="item">
                        <p>任务描述：</p>
                        <el-tooltip :disabled="item.taskContent.length<=13" :content="item.taskContent" effect="dark">
                            <p class="overflow">{{ item.taskContent }}</p>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="right-content-box">
                <course-card v-for="(item, index) in courseData" @to_detail="startTask(item)" :key="index" :hidePerson="true" :cardData="item"></course-card>
            </div>
        </div>
        <to-study ref="to_study"></to-study>
    </div>
</template>

<script>
import { PageMyTaskList } from '@/api/courseTask';
import {QueryCourseDetail} from '@/api/course';
import { filterTaskStatus } from '@/utils/utils';
import { isTimeArea } from '@/utils/utils';
import ToStudy from './ToStudy.vue';
import CourseCard from '../common/CourseCard.vue';
import NoData from '../../common/NoData.vue';
export default {
    components: { ToStudy, CourseCard, NoData },
    props: ['name'],
    data() {
        return {
            pages: {
                current: 1,
                size: 10,
                total: 0
            },
            tableData: [],
            currentId: '',
            tableKey: [
                {
                    name: '任务名称',
                    value: 'taskName'
                },
                {
                    name: '任务内容',
                    value: 'taskContent'
                },
                {
                    name: '发布时间',
                    value: 'releaseTime'
                },
                {
                    name: '',
                    value: 'operation',
                    slot: 'operation'
                },
            ]
        }
    },
    computed: {
        courseData() {
            let el = this.tableData.find(item => item.id == this.currentId);
            if (el) {
                return el.courseData;
            } else {
                return [];
            }
        }
    },
    methods: {
        filterTaskStatus,
        isTimeArea,
        load() {
            let total = this.pages.current * this.pages.size;
            if (total >= this.pages.total) return;
            this.pages.current++;
            this.pageMyTaskList();
        },
        /**展示课程任务 */
        showCourse(item) {
            this.currentId = item.id;
            this.pageMyTaskList();
        },
        showAllCourse(data) {
            if (!data || data.length == 0) return '';
            let arr = data.map(item => item.courseName);
            return arr.join(',');
        },
        pageMyTaskList() {
            let params = {
                "current": this.pages.current,
                "taskName": this.name,
                "size": this.pages.size
            };
            PageMyTaskList(params).then(res => {
                if (res.code == 200) {
                    if (this.pages.current == 1) {
                        this.tableData = res.data.records;
                    } else {
                        this.tableData = [...this.tableData, ...res.data.records];
                    }
                    this.pages.total = res.data.total;
                    if (this.tableData.length > 0 && !this.currentId) {
                        this.currentId = this.tableData[0].id;
                    }
                }
            })
        },
        /**去学习 */
        startTask(item) {
            QueryCourseDetail({id:item.id}).then(res=>{
                    if(res.code==200){
                        this.dialogVisible=false;
                        localStorage.setItem('course_study_back',this.$route.fullPath);
                        localStorage.setItem('base_detail',JSON.stringify(res.data));
                        this.$router.push({
                        path:'/course/studyCourse',
                        query: { id: item.id,openCourseId:item.openCourseId,courseLearningSource:'course_task'}
                    });      
                    }
                })
        },
        /**模糊查询 */
        search() {
            this.pages.current = 1;
            this.pageMyTaskList();
        },
    },
    mounted() {
        this.search();
    },
    activated(){
        this.search();
    }
}
</script>

<style lang="less" scoped>
.box {
    height: 100%;
}

.btn-button {
    width: 72px;
    height: 25px;
    color: #ffffff;
    background-color: var(--blue);
    border-radius: 0.6rem;
    display: flex;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}

.content-container {
    height: calc(100% - 2rem);
    display: flex;
}
.table-item {
    border-bottom: 1px solid #e0e8f2;
    padding: 2.4rem 3.7rem 2.2rem 6.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.label-status {
    padding: 0.2rem 0.5rem;
    border-radius: 0.4rem 0px 0.4rem 0px;
    color: #ffffff;
    margin-left: 14px;
}

.top-content {
    display: flex;
}

.bottom-content {
    margin-top: 12px;
    display: flex;
    font-size: 14px;
    color: #8590B3;

    &> :nth-child(n) {
        margin-left: 4.5rem;
    }

    &> :nth-child(1) {
        margin-left: 0;
    }
}

.item {
    display: flex;
    margin-top: 1rem;
}

.page-box {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2rem;
}

.detail-img {
    width: 2.1rem;
    margin-left: 1rem;
    cursor: pointer;
}

.left-content-box {
    width: 30rem;
    height: 100%;
    overflow: auto;
    background-color: #ffffff;
    .left-item {
        padding: 2rem;
        border-bottom: 1px solid #e0e8f2;
        cursor: pointer;

        .task-name {
            font-weight: 700;
            font-size: 16px;
        }
    }
}

.active-item {
    background-color: var(--blue) !important;
    color: #ffffff !important;
}

.right-content-box {
    width: calc(100% - 35rem);
    height: 100%;
    margin-left: 5rem;
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    overflow: auto;
    row-gap: 4rem;
    column-gap: 5rem;
}

/deep/.card-box {
    width: calc((100% - 10rem)/3);
}
@media screen and (max-width:750px){
    .content-container{
        flex-direction: column;
    }
    .left-content-box{
        height: auto;
        width: 100%;
        display: flex;
    }
    .right-content-box{
        margin-left: 0 !important;
        margin-top: 2rem;
        width: 100%;
        flex: 1;
    }
}
</style>